import { createSelector } from '@ngrx/store';
import { TimeDeviationDialogState } from './time-deviation-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den Time-Deviation-Dialog.
 */
export class TimeDeviationDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): TimeDeviationDialogState => state.timeDeviationDialog,
  );

  /**
   * Selector für den isOpen-Status.
   */
  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );
}
